<template>
  <div class="article-review">
    <div class="article-review_content">
      <div class="article-review_content-title">文章审核</div>
      <div class="article-review_content-option">
        <span class="article-review_content-option_status-title">
          审核状态
        </span>
        <a-select
          v-model="status"
          style="width: 160px"
          @change="handleChange"
        >
          <a-select-option value=''>全部</a-select-option>
          <a-select-option value='WAIT'>待审核</a-select-option>
          <a-select-option value='PASS'>审核通过</a-select-option>
          <a-select-option value='REJECT'>审核拒绝</a-select-option>
        </a-select>
      </div>
      <div class="article-review_content-list">
        <a-spin :spinning="spinning">
          <a-table :columns="columns" :data-source="articles" :pagination=false rowKey="id">
            <template
              slot="index"
              slot-scope="text, record, index"
            >
              <span>{{ index+1 }}</span>
            </template>
            <template
              slot="createTime"
              slot-scope="text"
            >
              <span :title="timeString(text)">{{ timeString(text) }}</span>
            </template>
            <template
              slot="updateTime"
              slot-scope="text"
            >
              <span :title="timeString(text)">{{ timeString(text) }}</span>
            </template>
            <template
              slot="auditState"
              slot-scope="text"
            >
              <a-badge :color="statusMap[text].color" :text="statusMap[text].text" />
            </template>
            <template
              slot="top"
              slot-scope="text"
            >
              <span>{{ text === 0 ? '否' : '是' }}</span>
            </template>
            <template
              slot="rowTitle"
              slot-scope="text, record"
            >
              <span :title="text" class="article-review_content-list-article" @click="onClickTitle(record.id)">{{ text }}</span>
            </template>
            <template
              slot="operation"
              slot-scope="text, record"
            >
              <a-button
                v-if="record.auditState !== 'REJECT'"
                class="article-review_content-list-button"
                type="link"
                @click="handleState('REJECT',record.id)"
              >
                拒绝
              </a-button>
              <a-button
                v-if="record.auditState !== 'PASS'"
                class="article-review_content-list-button"
                type="link"
                @click="handleState('PASS',record.id)"
              >
                通过
              </a-button>
              <a-button
                v-if="record.top === 0"
                class="article-review_content-list-button"
                type="link"
                @click="handleTop(1,record.id)"
              >
                置顶
              </a-button>
              <a-button
                v-if="record.top === 1"
                class="article-review_content-list-button"
                type="link"
                @click="handleTop(0,record.id)"
              >
                取消置顶
              </a-button>
            </template>
          </a-table>
          <div class="article-review_content-list-pagination">
            <a-pagination 
              v-model="pagination.pageNo" 
              :total="pagination.total" 
              :pageSizeOptions="['10', '30', '50', '100']"
              show-size-changer
              show-quick-jumper
              @change="change"
              @showSizeChange="showSizeChange"
              :show-total="total => `共 ${pagination.total} 条`"
            />
          </div>
        </a-spin>
      </div>
    </div>
  </div>
</template>

<script>
// import { articles } from './adminData'
import { getAdminArticles, setArticleAudit, setArticleTop } from '@/utils/api.js'
import { formatTime } from '@/utils'

export default {
  data() {
    return {
      spinning: false,
      articles: [],
      pagination: {
        pageNo: 1,
        limit: 10,
        total: 0
      },
      status: '',
      statusMap: {
        'WAIT': {
          color: 'rgba(4,12,44,0.25)',
          text: '待审核'
        },
        'PASS': {
          color: '#09A120 100%',
          text: '审核通过'
        },
        'REJECT': {
          color: '#F14500 100%',
          text: '审核拒绝'
        }
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          scopedSlots: { customRender: 'index' },
          width: '60px',
        },
        {
          title: '作者名称',
          dataIndex: 'createBy',
          key: 'createBy',
          width: '110px',
          ellipsis: true
        },
        {
          title: '审核状态',
          dataIndex: 'auditState',
          key: 'auditState',
          width: '110px',
          ellipsis: true,
          scopedSlots: { customRender: 'auditState' },
        },
        {
          title: '是否置顶',
          dataIndex: 'top',
          key: 'top',
          width: '100px',
          ellipsis: true,
          scopedSlots: { customRender: 'top' },
        },
        {
          title: '标题',
          dataIndex: 'title',
          key: 'title',
          width: '300px',
          ellipsis: true,
          scopedSlots: { customRender: 'rowTitle' },
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          ellipsis: true,
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          key: 'updateTime',
          ellipsis: true,
          scopedSlots: { customRender: 'updateTime' },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'right',
          width: '170px'
        }
      ]
    }
  },
  created() {
    this.queryList()
  },
  methods: {
    queryList() {
      this.spinning = true
      const params = {
        auditState: this.status,
        category: 'ARTICLE',
        limit: this.pagination.limit,
        pageNo: this.pagination.pageNo
      }
      getAdminArticles(params).then(res => {
        this.spinning = false
        if (res.code === 0) {
          this.articles = res.data.records.map(a => {
            a.title = decodeURI(a.title)
            return a
          })
          this.pagination.total = res.data.total
        } else {
          this.$message.error('获取文章列表失败')
        }
      })
    },
    handleChange() {
      this.queryList()
    },
    change() {
      this.queryList()
    },
    showSizeChange(current, size) {
      this.pagination.pageNo = 1
      this.pagination.limit = size
      this.queryList()
    },
    handleState(state,id) {
      this.spinning = true
      const params = {
        auditState: state,
        id: id
      }
      setArticleAudit(params).then(res => {
        if (res.code === 0) {
          this.queryList()
        } else {
          this.spinning = false
          this.$message.error('审核失败')
        }
      })
    },
    handleTop(top,id) {
      this.spinning = true
      const params = {
        id: id,
        top: top
      }
      setArticleTop(params).then(res => {
        if (res.code === 0) {
          this.queryList()
        } else {
          this.spinning = false
          this.$message.success('置顶失败')
        }
      })
    },
    onClickTitle(id) {
      window.open(`/poros-community/article-detail/${id}`)
    },
    timeString(time) {
      return formatTime(time)
    }
  }
}
</script>

<style lang="less" scoped>
.article-review {
  height: 100%;
  background: #f7f7f8;
  padding: 10px 10px 0 10px;
  overflow: hidden;
  display: flex;
  &_content {
    flex: 1;
    background: #ffffff;
    border: 1px solid rgba(229,230,233,1);
    display: flex;
    flex-direction: column;
    &-title {
      flex: 0;
      padding: 12px 20px;
      font-size: 16px;
      color: #040C2C;
      letter-spacing: 0;
      line-height: 24px;
      font-weight: 400;
      border-bottom : 1px solid rgba(229,230,233,1);
    }
    &-option {
      flex: 0;
      margin-top: 20px;
      height: 30px;
      display: flex;
      align-items: center;
      padding: 0 20px;
      &_status-title {
        font-size: 12px;
        color: rgba(4,12,44,0.85);
        letter-spacing: 0;
        line-height: 18px;
        font-weight: 400;
        margin-right: 10px;
      }
    }
    &-list {
      flex: 1;
      padding: 15px 20px;
      overflow-y: auto;
      &-button {
        padding: 0 0 0 10px;
      }
      &-article {
        cursor: pointer;
        font-size: 12px;
        color: #1740DC;
        letter-spacing: 0;
        line-height: 18px;
        font-weight: 400;
      }
      &-pagination {
        display: flex;
        justify-content: flex-end;
        // padding: 0 20px 20px 0;
        padding: 10px 0;
      }
    }
  }
}
</style>